import { useLocalStorage } from '@fourthwall/utils/dist/LocalStorage'

export type DashboardStorageStore = {
  // onboardingSkipped
  'onboardingSkipped.all'?: boolean
  'onboardingSkipped.customization'?: boolean
  'onboardingSkipped.firstProduct'?: boolean

  // recommendationsDismiss
  'recommendationsDismiss.campaign'?: boolean
  'recommendationsDismiss.addReferralLinkToHomepage'?: boolean
  'recommendationsDismiss.createProduct'?: boolean
  'recommendationsDismiss.bookACall'?: boolean
  'recommendationsDismiss.creatorChallenge'?: boolean
  'recommendationsDismiss.orderSamples'?: boolean
  'recommendationsDismiss.ordersToSend'?: boolean
  'recommendationsDismiss.integrations'?: boolean
  'recommendationsDismiss.payouts'?: boolean
  'recommendationsDismiss.domain'?: boolean
  'recommendationsDismiss.invite'?: boolean
  'recommendationsDismiss.promotions'?: boolean
  'recommendationsDismiss.freeShipping'?: boolean
  'recommendationsDismiss.social'?: boolean
  'recommendationsDismiss.creatorApp'?: boolean
  'recommendationsDismiss.helpCenter'?: boolean
  'recommendationsDismiss.twitchGifting'?: boolean
  'recommendationsDismiss.referral'?: boolean
  'recommendationsDismiss.twitchPromotion'?: boolean
  'recommendationsDismiss.youTubeProductShelf'?: boolean
  'recommendationsDismiss.thankYou'?: boolean
  'recommendationsDismiss.digitalProduct'?: boolean
  'recommendationsDismiss.memberships'?: boolean
  'recommendationsDismiss.joinDiscord'?: boolean
  'recommendationsDismiss.googleAnalytics'?: boolean

  // membershipsSuggestionsDismiss
  'membershipsSuggestionsDismiss.newPost'?: boolean
  'membershipsSuggestionsDismiss.welcomePost'?: boolean
  'membershipsSuggestionsDismiss.discord'?: boolean
  'membershipsSuggestionsDismiss.products'?: boolean
  'membershipsSuggestionsDismiss.promotions'?: boolean
  'membershipsSuggestionsDismiss.twitchDiscount'?: boolean
  'membershipsSuggestionsDismiss.spotify'?: boolean

  // launchStrategy
  'launchStrategy.category'?: number
  'launchStrategy.guide'?: number
  'launchStrategy.dismiss'?: boolean
  'launchStrategy.continueBar'?: boolean
}

const LOCAL_STORAGE_KEY = 'fourthwall.dashboard'

export const useDashboardStorage = () => {
  const { localStorage } = useLocalStorage<DashboardStorageStore>(LOCAL_STORAGE_KEY)

  return { dashboardStorage: localStorage }
}
